import { takeLatest, call, put } from 'redux-saga/effects';
import { uploadContent } from 'modules/common/api';

import { getAdvertsList, addAdvert, editAdvert } from './api';
import {
  fetchAdvertsListSuccess,
  fetchAdvertsListFail,
  fetchAddOrEditAdvertSubmissionSuccess,
  fetchAddOrEditAdvertSubmissionFail,
} from './actions';
import advertsActionTypes from './action-types';

function* fetchAdvertsListSaga({ payload }) {
  try {
    const response = yield call(getAdvertsList, payload);
    yield put(fetchAdvertsListSuccess(response.data.data));
  } catch (error) {
    yield put(fetchAdvertsListFail(error));
  }
}

function* fetchAddOrEditAdvertSubmissionSaga({ payload }) {
  const { addOrEditAdvertCallbackActionSuccess, actionPopupCallbackAction } = payload;

  try {
    const { advertKey } = payload;
    let response = {};

    if (advertKey) yield call(editAdvert, payload);
    else {
      const { imageData } = payload;
      const {
        data: { campaignKey },
      } = payload;

      const updatedPayload = { ...payload };

      if (imageData) {
        const uploadedContent = new FormData();
        uploadedContent.append('OperationKey', campaignKey);
        uploadedContent.append('Files', imageData);

        const headers = {
          'x-vzt-Component': 'AdsPortal',
          ServiceKey: 'adcampaign',
        };
        const data = uploadedContent;
        const body = {
          headers,
          data,
        };

        response = yield call(uploadContent, body);

        updatedPayload.data.fileUrl = response.data.data[0].fileUrl;
      }

      yield call(addAdvert, updatedPayload);
    }

    if (addOrEditAdvertCallbackActionSuccess) addOrEditAdvertCallbackActionSuccess();
    if (actionPopupCallbackAction) actionPopupCallbackAction(true);
    yield put(fetchAddOrEditAdvertSubmissionSuccess());
  } catch (error) {
    if (actionPopupCallbackAction) actionPopupCallbackAction();
    yield put(fetchAddOrEditAdvertSubmissionFail(error));
  }
}

function* advertsSaga() {
  yield takeLatest(advertsActionTypes.FETCH_ADVERTS_LIST, fetchAdvertsListSaga);
  yield takeLatest(
    advertsActionTypes.FETCH_ADD_OR_EDIT_ADVERT_SUBMISSION,
    fetchAddOrEditAdvertSubmissionSaga,
  );
}

export default advertsSaga;
